import { render } from "./SuccessPopup.vue?vue&type=template&id=37cf3ab3"
import script from "./SuccessPopup.vue?vue&type=script&lang=js"
export * from "./SuccessPopup.vue?vue&type=script&lang=js"
script.render = render

export default script